import Vue from 'vue'
import VueRouter from 'vue-router'
import Url from './urls.json'
import { canonical } from './canonical'
import { noindex } from './noindex'

Vue.use(VueRouter)

function Router (Lang) {
  var lang = Lang

  const router = new VueRouter({
    mode: 'history',
    routes: [
      // {
      //   path: '',
      //   component: () => import('@/desktop/views/Home')
      // },
      // {
      //   path: Url[lang]['HomePage'],
      //   name: 'HomePage',
      //   component: () => import('@/desktop/views/Home')
      // },
      {
        path: '',
        name: 'MainPage',
        meta: { layout: 'ibranch', isPost: false },
        component: () => import('@/desktop/views/login')
      },
      {
        path: Url[lang]['HomePage'],
        name: 'HomePage',
        meta: { layout: 'ibranch', isPost: false },
        component: () => import('@/desktop/views/login')
      },
      {
        path: Url[lang]['Personal'],
        name: 'Personal',
        meta: { layout: 'ibranch', isPost: true },
        component: () => import('@/desktop/views/post/Personal')
      },
      {
        path: Url[lang]['AgencyPersonal'],
        name: 'AgencyPersonal',
        meta: { layout: 'ibranch', isPost: true, isAgency: true },
        component: () => import('@/desktop/views/post/agencyPersonal')
      },
      {
        path: Url[lang]['AgencyNewRequest'],
        name: 'AgencyNewRequest',
        meta: { layout: 'ibranch', isPost: true, isAgency: true },
        component: () => import('@/desktop/views/post/agencyNewRequest')
      },
      {
        path: Url[lang]['AgencyRequestTrack'],
        name: 'AgencyRequestTrack',
        meta: { layout: 'ibranch', isPost: true, isAgency: true },
        component: () => import('@/desktop/views/post/agencyRequestTrack')
      },
      {
        path: Url[lang]['AgencyEducation'],
        name: 'AgencyEducation',
        meta: { layout: 'ibranch', isPost: true, isAgency: true },
        component: () => import('@/desktop/views/post/agencyEducation')
      },
      {
        path: Url[lang]['AgencyAnnouncement'],
        name: 'AgencyAnnouncement',
        meta: { layout: 'ibranch', isPost: true, isAgency: true },
        component: () => import('@/desktop/views/post/agencyAnnouncement')
      },
      {
        path: Url[lang]['AgencyForm'],
        name: 'AgencyForm',
        meta: { layout: 'ibranch', isPost: true, isAgency: true },
        component: () => import('@/desktop/views/post/agencyForm')
      },
      {
        path: Url[lang]['AgencyPageView'],
        name: 'AgencyPageView',
        meta: { layout: 'ibranch', isPost: true, isAgency: true },
        component: () => import('@/desktop/views/post/agencyPageView')
      },
      // {
      //   path: Url[lang]['Nav'],
      //   name: 'Nav',
      //   redirect: { name: 'Info' }
      // },
      // {
      //   path: Url[lang]['Info'],
      //   name: 'Info',
      //   component: () => import('@/desktop/views/products/info/index')
      // },
      // {
      //   path: Url[lang]['Search'],
      //   name: 'Search',
      //   component: () => import('@/desktop/views/search')
      // },
      // {
      //   path: Url[lang]['Traffic'],
      //   name: 'Traffic',
      //   meta: { layout: 'proposal' },
      //   component: () => import('@/desktop/views/products/proposal/traffic')
      // },
      // {
      //   path: Url[lang]['Travel'],
      //   name: 'Travel',
      //   meta: { layout: 'proposal' },
      //   component: () => import('@/desktop/views/products/proposal/travel')
      // },
      // {
      //   path: Url[lang]['PersonalAccident'],
      //   name: 'PersonalAccident',
      //   meta: { layout: 'proposal' },
      //   component: () => import('@/desktop/views/products/proposal/personalAccident')
      // },
      // {
      //   path: Url[lang]['Motor'],
      //   name: 'Motor',
      //   meta: { layout: 'proposal' },
      //   component: () => import('@/desktop/views/products/proposal/motor')
      // },
      // {
      //   path: Url[lang]['Dask'],
      //   name: 'Dask',
      //   meta: { layout: 'proposal' },
      //   component: () => import('@/desktop/views/products/proposal/dask')
      // },
      // {
      //   path: Url[lang]['Home'],
      //   name: 'Home',
      //   meta: { layout: 'proposal' },
      //   component: () => import('@/desktop/views/products/proposal/home')
      // },
      // {
      //   path: Url[lang]['FourSeasonsHealth'],
      //   name: 'FourSeasonsHealth',
      //   meta: { layout: 'proposal' },
      //   component: () => import('@/desktop/views/products/proposal/fourSeasonsHealth')
      // },
      // {
      //   path: Url[lang]['SupplementalHealth'],
      //   name: 'SupplementalHealth',
      //   meta: { layout: 'proposal' },
      //   component: () => import('@/desktop/views/products/proposal/supplementalHealth')
      // },
      // {
      //   path: Url[lang]['DigitalProtection'],
      //   name: 'DigitalProtectionInsurance',
      //   meta: { layout: 'proposal' },
      //   component: () => import('@/desktop/views/products/proposal/digitalprotectioninsurance')
      // },
      // {
      //   path: Url[lang]['Shopping'],
      //   name: 'ShoppingInsurance',
      //   meta: { layout: 'proposal' },
      //   component: () => import('@/desktop/views/products/proposal/shoppingInsurance')
      // },
      // {
      //   path: Url[lang]['ProposalInfoView'],
      //   name: 'ProposalInfoView',
      //   meta: { layout: 'proposal' },
      //   component: () => import('@/shared/views/products/proposal/proposalInfo')
      // },
      // {
      //   path: Url[lang]['PaymentView'],
      //   name: 'PaymentView',
      //   meta: { layout: 'proposal' },
      //   component: () => import('@/desktop/views/products/proposal/payment')
      // },
      // {
      //   path: Url[lang]['PaymentResultView'],
      //   name: 'PaymentResultView',
      //   meta: { layout: 'proposal' },
      //   component: () => import('@/desktop/views/products/proposal/paymentResult')
      // },
      // {
      //   path: Url[lang]['RenewalResultView'],
      //   name: 'RenewalResultView',
      //   meta: { layout: 'proposal' },
      //   component: () => import('@/desktop/views/products/proposal/renewalResult')
      // },
      // {
      //   path: Url[lang]['EurekoCorporate'],
      //   name: 'EurekoCorporate',
      //   component: () => import('@/desktop/views/corporate/eurekoCorporate')
      // },
      // {
      //   path: Url[lang]['Sustainability'],
      //   name: 'Sustainability',
      //   component: () => import('@/desktop/views/corporate/sustainability')
      // },
      // {
      //   path: Url[lang]['PressRoom'],
      //   name: 'PressRoom',
      //   component: () => import('@/desktop/views/corporate/pressRoom')
      // },
      // {
      //   path: Url[lang]['Career'],
      //   name: 'Career',
      //   component: () => import('@/desktop/views/corporate/career')
      // },
      // {
      //   path: Url[lang]['SocialResponsibility'],
      //   name: 'SocialResponsibility',
      //   component: () => import('@/desktop/views/corporate/socialResponsibility')
      // },
      // {
      //   path: Url[lang]['CustomerSatisfaction'],
      //   name: 'CustomerSatisfaction',
      //   component: () => import('@/desktop/views/corporate/customerSatisfaction')
      // },
      // {
      //   path: Url[lang]['ContactForm'],
      //   name: 'ContactForm',
      //   component: () => import('@/desktop/views/corporate/contactForm')
      // },
      // {
      //   path: Url[lang]['ExpertApplyForm'],
      //   name: 'ExpertApplyForm',
      //   component: () => import('@/desktop/views/corporate/expertApplyForm')
      // },
      // {
      //   path: Url[lang]['ContractedProvidersForm'],
      //   name: 'ContractedProvidersForm',
      //   component: () => import('@/desktop/views/corporate/contractedServiceApply')
      // },
      // {
      //   path: Url[lang]['AgencyApplyForm'],
      //   name: 'AgencyApplyForm',
      //   component: () => import('@/desktop/views/corporate/agencyApplyForm')
      // },
      // {
      //   path: Url[lang]['InformationForms'],
      //   name: 'InformationForms',
      //   component: () => import('@/desktop/views/products/informationForms')
      // },
      // {
      //   path: Url[lang]['Vale'],
      //   name: 'Vale',
      //   component: () => import('@/desktop/views/services/vale')
      // },
      // {
      //   path: Url[lang]['ServicePoint'],
      //   name: 'ServicePoint',
      //   component: () => import('@/desktop/views/services/servicePoint')
      // },
      // {
      //   path: Url[lang]['MiniDamage'],
      //   name: 'MiniDamage',
      //   component: () => import('@/desktop/views/services/miniDamage')
      // },
      // {
      //   path: Url[lang]['Faq'],
      //   name: 'Faq',
      //   component: () => import('@/desktop/views/insuranceForEveryone/faq')
      // },
      // {
      //   path: Url[lang]['FeaturedProducts'],
      //   name: 'FeaturedProducts',
      //   component: () => import('@/desktop/views/insuranceForEveryone/featuredProducts')
      // },
      {
        path: Url[lang]['Profile'],
        name: 'Profile',
        meta: { layout: 'ibranch', isPost: true },
        component: () => import('@/desktop/views/post/personal/profile')
      },
      {
        path: Url[lang]['Proposals'],
        name: 'Proposals',
        meta: { layout: 'ibranch', isPost: true },
        component: () => import('@/desktop/views/post/personal/proposals')
      },
      {
        path: Url[lang]['Policies'],
        name: 'Policies',
        meta: { layout: 'ibranch', isPost: true },
        component: () => import('@/desktop/views/post/personal/policies')
      },
      {
        path: Url[lang]['Claims'],
        name: 'Claims',
        meta: { layout: 'ibranch', isPost: true },
        component: () => import('@/desktop/views/post/personal/claims')
      },
      {
        path: Url[lang]['PolicyDetail'],
        name: 'PolicyDetail',
        meta: { layout: 'ibranch', isPost: true },
        component: () => import('@/desktop/views/post/personal/policyDetail')
      },
      {
        path: Url[lang]['ClaimDetail'],
        name: 'ClaimDetail',
        meta: { layout: 'ibranch', isPost: true },
        component: () => import('@/desktop/views/post/personal/claimDetail')
      },
      {
        path: Url[lang]['ProposalDetail'],
        name: 'ProposalDetail',
        meta: { layout: 'ibranch', isPost: true },
        component: () => import('@/desktop/views/post/personal/proposalDetail')
      },
      {
        path: Url[lang]['CreditCardDetail'],
        name: 'CreditCardDetail',
        meta: { layout: 'ibranch', isPost: true },
        component: () => import('@/desktop/views/post/personal/creditCardDetail')
      },
      {
        path: Url[lang]['InvoiceUpload'],
        name: 'InvoiceUpload',
        meta: { layout: 'ibranch', isPost: true },
        component: () => import('@/desktop/views/post/personal/invoiceUpload')
      },
      {
        path: Url[lang]['InvoiceTrack'],
        name: 'InvoiceTrack',
        meta: { layout: 'ibranch', isPost: true },
        component: () => import('@/desktop/views/post/personal/invoiceTrack')
      },
      {
        path: Url[lang]['DigitalCampaigns'],
        name: 'DigitalCampaigns',
        meta: { layout: 'ibranch', isPost: true },
        component: () => import('@/desktop/views/post/personal/digitalCampaigns')
      },
      {
        path: Url[lang]['Login'],
        name: 'Login',
        meta: { layout: 'ibranch', isPost: false },
        component: () => import('@/desktop/views/login')
      },
      // {
      //   alias: '/tr/anlasmali-servisler',
      //   path: Url[lang]['Contractedproviders'],
      //   name: 'Contractedproviders',
      //   component: () => import('@/desktop/views/ContractedProviders')
      // },
      // {
      //   path: Url[lang]['Disclaimer'],
      //   name: 'Disclaimer',
      //   component: () => import('@/desktop/views/Disclaimer')
      // },
      // {
      //   path: Url[lang]['WhyInsurance'],
      //   name: 'WhyInsurance',
      //   component: () => import('@/desktop/views/whyInsurance')
      // },
      // {
      //   path: Url[lang]['Kvkk'],
      //   name: 'Kvkk',
      //   component: () => import('@/desktop/views/legalInfo/kvkk')
      // },
      // {
      //   path: Url[lang]['Mediation'],
      //   name: 'Mediation',
      //   component: () => import('@/desktop/views/legalInfo/mediation')
      // },
      // {
      //   path: Url[lang]['Cookie'],
      //   name: 'Cookie',
      //   component: () => import('@/desktop/views/legalInfo/cookie')
      // },
      // {
      //   path: Url[lang]['Information'],
      //   name: 'Information',
      //   component: () => import('@/desktop/views/legalInfo/information')
      // },
      // {
      //   path: Url[lang]['Query'],
      //   name: 'Query',
      //   component: () => import('@/desktop/views/legalInfo/query')
      // },
      // {
      //   path: Url[lang]['InstantDamage'],
      //   name: 'InstantDamage',
      //   component: () => import('@/desktop/views/damage/instantDamage')
      // },
      {
        path: Url[lang]['DamageNotice'],
        name: 'DamageNotice',
        meta: { layout: 'empty' },
        component: () => import('@/desktop/views/damage/damageNotice')
      },
      // {
      //   path: Url[lang]['DamageInquiry'],
      //   name: 'DamageInquiry',
      //   meta: { layout: 'empty' },
      //   component: () => import('@/desktop/views/damage/damageInquiry')
      // },
      // {
      //   path: Url[lang]['DamageFaq'],
      //   name: 'DamageFaq',
      //   component: () => import('@/desktop/views/damage/faq')
      // },
      // {
      //   path: Url[lang]['TrafficCalculator'],
      //   name: 'TrafficCalculator',
      //   component: () => import('@/desktop/views/calculator/trafficCalculator')
      // },
      // {
      //   path: Url[lang]['InfoCorporate'],
      //   name: 'InfoCorporate',
      //   component: () => import('@/desktop/views/products/corporate/index')
      // },
      // {
      //   path: Url[lang]['CallCenter'],
      //   name: 'CallCenter',
      //   component: () => import('@/desktop/views/callCenter')
      // },
      {
        path: Url[lang]['RemainingLimit'],
        name: 'RemainingLimit',
        meta: { layout: 'ibranch', isPost: true },
        component: () => import('@/desktop/views/post/personal/remainingLimit')
      },
      {
        path: Url[lang]['PersonsClaim'],
        name: 'PersonsClaim',
        meta: { layout: 'ibranch', isPost: true },
        component: () => import('@/desktop/views/post/personal/personsClaim')
      },
      {
        path: Url[lang]['CustomerDocuments'],
        name: 'CustomerDocuments',
        meta: { layout: 'ibranch', isPost: true },
        component: () => import('@/desktop/views/post/personal/customerDocuments')
      },
      // {
      //   path: Url[lang]['KvkkConfirm'],
      //   name: 'KvkkConfirm',
      //   meta: { layout: 'no-footer', noindex: true },
      //   component: () => import('@/shared/views/kvkkConfirm')
      // },
      // {
      //   path: Url[lang]['WhatsAppKvkkConfirm'],
      //   name: 'WhatsAppKvkkConfirm',
      //   meta: { layout: 'no-footer', noindex: true },
      //   component: () => import('@/shared/views/whatsappKvkkConfirm')
      // },
      // {
      //   path: Url[lang]['CustomerInteraction'],
      //   name: 'CustomerInteraction',
      //   meta: { layout: 'no-footer', noindex: true },
      //   component: () => import('@/shared/widget/customerInteraction')
      // },
      // {
      //   path: Url[lang]['HealthCheck'],
      //   name: 'HealthCheck',
      //   meta: { layout: 'empty' },
      //   component: () => import('@/shared/views/healthCheck')
      // },
      // {
      //   path: Url[lang]['OpenLine'],
      //   name: 'OpenLine',
      //   meta: { layout: 'no-footer', noindex: true },
      //   component: () => import('@/shared/views/openLine')
      // },
      // {
      //   path: Url[lang]['MobilAppIntro'],
      //   name: 'MobilAppIntro',
      //   component: () => import('@/desktop/views/mobilApp/intro')
      // },
      // {
      //   path: Url[lang]['LandingPage'],
      //   name: 'LandingPage',
      //   meta: { layout: 'empty', noindex: true },
      //   component: () => import('@/desktop/views/landing/index')
      // },
      // {
      //   path: Url[lang]['PromotionLandingPage'],
      //   name: 'PromotionLandingPage',
      //   component: () => import('@/desktop/views/landing/promotionPage')
      // },
      // {
      //   path: Url[lang]['SurveyPage'],
      //   name: 'SurveyPage',
      //   meta: { layout: 'no-footer', noindex: true },
      //   component: () => import('@/shared/views/survey')
      // },
      // {
      //   path: Url[lang]['Campaigns'],
      //   name: 'Campaigns',
      //   meta: { layout: 'empty' },
      //   component: () => import('@/desktop/views/campaigns/index')
      // },
      // {
      //   path: Url[lang]['HomeCampaigns'],
      //   name: 'HomeCampaigns',
      //   component: () => import('@/desktop/views/homeCampaigns/allCampaigns')
      // },
      // {
      //   path: Url[lang]['HomeCampaign'],
      //   name: 'HomeCampaigns',
      //   component: () => import('@/desktop/views/homeCampaigns/allCampaigns')
      // },
      // {
      //   path: Url[lang]['CampaignDetail'],
      //   name: 'CampaignDetail',
      //   component: () => import('@/desktop/views/homeCampaigns/campaign')
      // },
      // {
      //   path: Url[lang]['ModularPersonalAccident'],
      //   name: 'ModularPersonalAccident',
      //   component: () => import('@/desktop/views/productLanding/personalAccident')
      // },
      // {
      //   path: Url[lang]['ProductLandingForm'],
      //   name: 'ProductLandingForm',
      //   component: () => import('@/shared/widget/productLanding/productLandingForm')
      // },
      // {
      //   path: '/test',
      //   name: 'Test',
      //   component: () => import('@/desktop/views/test')
      // },
      {
        path: '/401Error',
        name: 'Error401',
        meta: { layout: 'ibranch', isPost: true, isAgency: true, noindex: true },
        component: () => import('@/desktop/views/401')
      },
      {
        path: '/500Error',
        name: '500Error',
        meta: { noindex: true },
        component: () => import('@/desktop/views/500')
      },
      {
        path: '/UnderConstruction',
        name: 'UnderConstruction',
        meta: { layout: 'empty', noindex: true },
        component: () => import('@/desktop/views/underConstruction')
      },
      // {
      //   path: Url[lang]['AchmeaPrograme2023'],
      //   name: 'AchmeaPrograme2023',
      //   meta: { layout: 'default', noindex: true },
      //   component: () => import('@/shared/views/AchmeaPrograme2023')
      // },
      // {
      //   path: Url[lang]['MobileApp'],
      //   name: 'MobileApp',
      //   meta: { layout: 'empty', noindex: true },
      //   component: () => import('@/shared/views/MobileApp')
      // },
      {
        path: '/404Error',
        name: '404Error',
        meta: { layout: 'ibranch', noindex: true },
        component: () => import('@/desktop/views/404')
      },
      {
        path: '*',
        meta: { layout: 'ibranch', noindex: true },
        component: () => import('@/desktop/views/404')
      }
    ]
  })

  router.beforeEach(function (to, from, next) {
    var userValid = false
    var customer = window.getCustomer()
    userValid = (customer.customerNo) && true

    canonical.add(lang, to.path, to.name, to.params)
    canonical.addLanguage(lang, to.path, to.name, to.params)
    canonical.addMobile(to.path)
    if (noindex.update(to.meta)) {
      canonical.remove(lang, to.path, to.name, to.params)
    }

    var scrollpx = 0
    var waitTime = 0

    setTimeout(function () { window.scrollTo(0, scrollpx) }, waitTime)
    /* eslint-disable no-undef */
    /* eslint-disable no-undefined */
    if (to.name !== 'PaymentView') {
      // Insider Start
      if (typeof window.spBackup !== 'undefined') {
        spApi = window.spBackup
        window.spBackup = undefined
      }
    } else {
      // Insider Pause
      if (typeof spApi !== 'undefined') {
        window.spBackup = spApi
        spApi = undefined
      }
    }
    /* isPost, isAgency and agency authorizations control */
    const agencyRoutePermissions = {
      AgencyNewRequest: 'uploadDemand',
      AgencyRequestTrack: 'listDemand'
    }

    if (to.meta && to.meta['isPost'] && !userValid) {
      next({ name: 'MainPage' })
    }

    if (to.meta && to.meta['isAgency']) {
      const agencyAuths = window.getAgencyAuthorizations()

      if (!agencyAuths.webLogin && to.name !== 'Error401') {
        return next({ name: 'Error401' })
      }

      const requiredPermission = agencyRoutePermissions[to.name]

      if (requiredPermission && !agencyAuths[requiredPermission] && to.name !== 'Error401') {
        return next({ name: 'Error401' })
      }
    }
    // GTM Page View Tracking for Post-Login and Agency Pages
    if (to.meta && to.meta.isPost && userValid) {
      const isAgency = !!(customer.agencyNo && customer.agencyNo !== 0)
      var pageIdentifier = to.name || to.path || 'Unknown Page'
      if (isAgency && (pageIdentifier === '/')) {
        pageIdentifier = '/acente-bireysel-sube'
      }
      var gtmEvent = {
        event: 'view',
        category: pageIdentifier,
        action: 'view',
        user_category: isAgency ? 'Agency' : 'Individual',
        agency_no: isAgency ? customer.agencyNo.toString() : '',
        noninteraction: true // Sayfa görüntüleme pasif bir işlem olduğu için true
      }
      // console.log('GTM View Tracked:', gtmEvent)
      Vue.gtm.trackEvent(gtmEvent)
    }

    next()
  })
  return router
}

export default Router



// WEBPACK FOOTER //
// ./src/router/desktop.js